import { render, staticRenderFns } from "./WorkflowStorageConfiguration.vue?vue&type=template&id=c1b01fc8"
import script from "./WorkflowStorageConfiguration.vue?vue&type=script&lang=js"
export * from "./WorkflowStorageConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports